import { CommonModule } from '@angular/common';
import { Component, DestroyRef, OnInit, inject } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatButtonModule } from '@angular/material/button';
import { MatCard } from '@angular/material/card';
import { TranslocoModule } from '@jsverse/transloco';
import { filter, switchMap } from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ClientService } from 'src/app/core/services/client.service';
import { Client } from 'src/app/domain/models';
import { GoogleAnalyticsService } from 'src/app/shared/service/google-analytics.service';
import { Application, ProviderContact } from '../../models';
import { ApplicationService } from '../../services';
import { CurrentApplicationService } from '../../services/current-application.service';

@Component({
    selector: 'app-application-confirmation',
    templateUrl: './application-confirmation.component.html',
    styleUrls: ['./application-confirmation.component.scss'],
    standalone: true,
    imports: [
        TranslocoModule,
        CommonModule,
        MatCard,
        FlexLayoutModule,
        MatButtonModule
    ]
})
export class ApplicationConfirmationComponent implements OnInit {
    providerContacts: ProviderContact[] | undefined;
    client: Client | undefined;

    private readonly destroyRef = inject(DestroyRef);

    constructor(
        private readonly applicationService: ApplicationService,
        private readonly currentAppService: CurrentApplicationService,
        private readonly _client: ClientService,
        private _googleAnalyticsService: GoogleAnalyticsService
    ) {
        this.currentAppService.load();
    }

    ngOnInit() {
        this._googleAnalyticsService.pageView('Application: Complete');
        this._client.latest
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((client) => {
                this.client = client;
            });
        this.currentAppService.latest
            .pipe(
                filter(
                    (application) =>
                        application !== null &&
                        application !== undefined &&
                        application.applicationId != undefined
                ),
                switchMap((application: Application | undefined) =>
                    this.applicationService.getSelectedProviderContacts(
                        application!.applicationId!
                    )
                ),
                takeUntilDestroyed(this.destroyRef)
            )
            .subscribe((result) => {
                this.providerContacts = result;
            });
    }
}
